module.exports = __webpack_public_path__ + "media/img/background-lms-114d593511446b9a4c6e340f7fef5c84.png";